/**
 * DocumentDetails Modal component module.
 * @module shared/components/modals/content/DocumentDetails
 *
 */

import React from 'react';
import {connect} from 'react-redux';
import BaseModal from '../types/Base';
import {_openModal, _removeModal} from '../../../store';
import PropTypes from 'prop-types';
import {Button, DescriptiveText, Row} from '../../../../shared';
import history from '../../../../history';
import {setSectionURI, openDocument, getShareText} from '../../../utils/utils';
import Details from '../../../../shared/pages/InfoPanels/Details';

/**
 * Document Details modal component to view document details.
 * @name DocumentDetails
 */
const DocumentDetails = props => {
  const {removeModal, content, session, openModal} = props;

  const doc = content.document;
  const {disableShareDetails, shareText} = getShareText(content.document, content.compliance, session.profile.id);
  return <BaseModal onClose={() => removeModal(content)} title={doc.title} size='lg'>
    <Row margin='0 0 10px 0' justifySubRow='left'>
      <Button importance='secondary'
              size='md'
              label='View Document'
              width='150px'
              action={() => {
                openDocument(doc, content.dataManager, content.compliance);
                removeModal(content);
              }}
      />
      <Button importance='secondary'
              size='md'
              label='Share Details'
              width='150px'
              action={() => {
                if (disableShareDetails) {
                  openModal({
                    type: 'MessageModal',
                    title: 'Share Details',
                    body: shareText,
                  });
                } else {
                  // TODO determine proper routing for investor here; can use content.hideDocumentDetails as investor condition
                  history.push(setSectionURI(`/${doc.id}/sharing`));
                }
                removeModal(content);
              }}
      />
    </Row>
    <DescriptiveText margin='0 5px 20px 5px' alignment='left'>
      {shareText}
    </DescriptiveText>
    <Details id={doc.id} dataManager={content.dataManager} compliance={content.compliance} isDetailsModal={true}/>
  </BaseModal>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  openModal: modal => dispatch(_openModal(modal)),
  removeModal: modal => dispatch(_removeModal(modal)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDetails);

DocumentDetails.propTypes = {
  /**
   * Is Session Reducer
   */
  session: PropTypes.shape({profile: PropTypes.shape({id: PropTypes.number.isRequired})}).isRequired,
  /**
   * content of the modal with modal component name
   */
  content: PropTypes.shape({
    type: PropTypes.string.isRequired,
    /**
     * document object being displayed in the modal
     */
    document: PropTypes.object.isRequired,
    /**
     * dataManager for updating document
     */
    dataManager: PropTypes.object.isRequired,
    /**
     * If true passes compliance to the api indicating that it's on a compliance related page
     */
    compliance: PropTypes.bool,
    /**
     * Whether parent is mounted
     */
    isMounted: PropTypes.bool,
  }),
  /**
   * The open modal function to dispatch _openModal from Redux
   */
  openModal: PropTypes.func.isRequired,
  /**
   * The remove modal function to dispatch _removeModal from Redux
   */
  removeModal: PropTypes.func.isRequired,
};
